export default __webpack_public_path__ + "static/media/ManagerAvatar.43b8d70f.svg";